import OptionFilter from "./OptionFilter";
import type { ProductKind } from "../lib/stockHealth";

interface Props {
  value: Set<ProductKind>;
  onChange: (next: Set<ProductKind>) => void;
  counts: Record<ProductKind, number>;
}

export const KIND_LABEL: Record<ProductKind, string> = {
  for_sale: "For sale",
  gift: "Gifts",
  not_moving: "Not moving",
};

// What each kind holds, spelled out under its option.
const RULE: Record<ProductKind, string> = {
  for_sale: "Sold or gifted in the last 90 days, less than 90% as gifts.",
  gift: "90% or more of the units in the last 90 days went out as gifts.",
  not_moving: "Nothing sold or gifted in the last 90 days. New: first in stock in the last 90 days.",
};

const KINDS = Object.keys(KIND_LABEL) as ProductKind[];

// "Show: All" filter that splits the stock list by how it moved over the last
// 90 days (see Inventory::StockHealth). Nothing picked shows every product.
export default function ProductKindFilter({ value, onChange, counts }: Props) {
  return (
    <OptionFilter
      label="Show"
      options={KINDS.map((kind) => ({
        key: kind,
        label: `${KIND_LABEL[kind]} (${counts[kind].toLocaleString()})`,
        description: RULE[kind],
      }))}
      selected={value}
      onChange={(next) => onChange(next as Set<ProductKind>)}
      summaryLabel={(key) => KIND_LABEL[key as ProductKind]}
      width="w-80"
    />
  );
}
